export default __webpack_public_path__ + "static/03_process-e71a7a8a759b9f8654fb4c5d0baac5b2.webm";